<template>
  <div class="col-md-12">
    <div class="card card-container">
      <img
        id="profile-img"
        src="/img/logo_mag.svg"
        class="profile-img-card"
      />
      <Form @submit="handleLogin" :validation-schema="schema">
        <div class="text-field__icon">
          <label for="username" class="bold">Логин</label>
          <Field name="username" type="text" class="text-field__input" style="width: 85%;"/>
          <ErrorMessage name="username" class="error-feedback small" />
        </div>
        <div class="text-field__icon">
          <label for="password" class="bold">Пароль</label>
          <Field name="password" type="password" class="text-field__input" style="width: 85%;"/>
          <ErrorMessage name="password" class="error-feedback small" />
        </div>

        <div class="text-field__icon">
          <button class="btn btn-primary btn-block" style="margin-top:32px;" :disabled="loading">
            <span
              v-show="loading"
              class="spinner-border spinner-border-sm"
            ></span>
            <span>Войти</span>
          </button>
        </div>

        <div class="form-group" style="margin-top: 20px; color: red">
          <div v-if="message" class="alert alert-danger" role="alert">
            {{ message }}
            <strong>Забыли пароль? </strong><a href="/login/reset">Восстановить</a>
          </div>
        </div>
      </Form>
      
    </div>
  </div>
</template>
  
  <script>
  import { Form, Field, ErrorMessage } from "vee-validate";
  import * as yup from "yup";
  
  export default {
    name: "Login",
    components: {
      Form,
      Field,
      ErrorMessage,
    },
    data() {
      const schema = yup.object().shape({
        username: yup.string().required("Необходимо ввести логин!"),
        password: yup.string().required("Необходимо ввести пароль!"),
      });
  
      return {
        loading: false,
        message: "",
        schema,
      };
    },
    computed: {
      loggedIn() {
        return this.$store.state.auth.status.loggedIn;
      },
    },
    created() {
      if (this.loggedIn) {
        this.$router.push("/");
      }
    },
    methods: {
      handleLogin(user) {
        this.loading = true;
  
        this.$store.dispatch("auth/login", user).then(
          () => {
            this.$router.push("/");
          },
          (error) => {
            this.loading = false;
            this.message = "Неверное имя пользователя или пароль"
              // (error.response &&
              //   error.response.data &&
              //   error.response.data.message) ||
              // error.message ||
              // error.toString();
          }
        );
      },
    },
  };
  </script>
  
  <style scoped>
  label {
    display: block;
    margin-top: 10px;
  }
  
  .card-container.card {
    max-width: 350px !important;
    padding: 40px 40px;
  }
  
  .card {
    background-color: #f7f7f7;
    padding: 20px 25px 30px;
    margin: 0 auto 25px;
    margin-top: 50px;
    -moz-border-radius: 2px;
    -webkit-border-radius: 2px;
    border-radius: 2px;
    -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  }
  
  .profile-img-card {

    margin: 0 auto 10px;
    display: block;

  }
  </style>